import { render, staticRenderFns } from "./vc-alert.vue?vue&type=template&id=3d087bb4&scoped=true&"
import script from "./vc-alert.vue?vue&type=script&lang=js&"
export * from "./vc-alert.vue?vue&type=script&lang=js&"
import style0 from "./vc-alert.vue?vue&type=style&index=0&id=3d087bb4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d087bb4",
  null
  
)

export default component.exports